import React from 'react';
import MenuCartAction from './MenuCartAction';
import MenuPlanAction from './MenuPlanAction';

/**
 * Our Menu CTAs: Add to cart + Add to plan on every surface.
 * Options and/or add-ons open the shared details sheet via onOpenOptions (with cart/plan intent).
 */
export default function MenuItemActions({
  item,
  orderable = true,
  unavailableLabel = 'Unavailable',
  variant = 'card',
  className = '',
  addedClassName = '',
  planClassName = '',
  onAfterAdd,
  onOpenOptions,
  selectedVariant = null,
  selectedAddOns = [],
  /** When 'plan', emphasize Add to Plan (e.g. modal opened from plan CTA). */
  primaryAction = 'cart',
  /** When set, cart CTA updates this line instead of adding. */
  editCartKey = null,
  /** When set, plan CTA updates this subscription-cart line instead of adding. */
  editPlanLineKey = null,
  /** Preserve meal slot when editing a plan line from the builder. */
  editSlotId = null,
  /** Plate qty from details modal. */
  draftQuantity = 1,
}) {
  if (!orderable && variant !== 'modal') {
    return (
      <div className={`menu-item-actions menu-item-actions--${variant}`}>
        <button
          type="button"
          className={`${className} menu-item__cta--oos`.trim()}
          disabled
          aria-disabled="true"
        >
          {unavailableLabel}
        </button>
      </div>
    );
  }

  const cart =
    !editPlanLineKey ? (
      <MenuCartAction
        key="cart"
        item={item}
        orderable={orderable}
        unavailableLabel={unavailableLabel}
        variant={variant}
        className={className}
        addedClassName={addedClassName}
        onAfterAdd={onAfterAdd}
        onOpenOptions={onOpenOptions}
        selectedVariant={selectedVariant}
        selectedAddOns={selectedAddOns}
        editCartKey={editCartKey}
        draftQuantity={draftQuantity}
      />
    ) : null;

  const plan =
    orderable && !editCartKey ? (
      <MenuPlanAction
        key="plan"
        item={item}
        orderable
        variant={variant}
        className={planClassName}
        onOpenOptions={onOpenOptions}
        selectedVariant={selectedVariant}
        selectedAddOns={selectedAddOns}
        draftQuantity={draftQuantity}
        editPlanLineKey={editPlanLineKey}
        editSlotId={editSlotId}
        onAfterAdd={onAfterAdd}
      />
    ) : null;

  const effectivePrimary = editPlanLineKey
    ? 'plan'
    : editCartKey
      ? 'cart'
      : primaryAction;
  const actions = effectivePrimary === 'plan' ? [plan, cart] : [cart, plan];

  return (
    <div
      className={`menu-item-actions menu-item-actions--${variant}${
        effectivePrimary === 'plan' ? ' menu-item-actions--primary-plan' : ''
      }`}
    >
      {actions.filter(Boolean)}
    </div>
  );
}
